import React, { useCallback, useEffect, useRef, useState } from "react";
import { FocusSDK, isFocusEnv } from "@/utils";
import styles from "./index.module.less";
import IconFont from "@/components/icon";
import Dayjs from "dayjs";
import Bus from "@/utils/bus";
import i18n from "@/i18n";
import ImService from "@/server/ImService";
import colors from "@/components/styles/colors";
import { analysisLog } from "@/utils/logAnalytics";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { ScheduleDetailFrom } from "@/components/Calendars/Schedule/Detail";
export default function CalendarNoticeCard({
  params,
  closeCurWindow,
  winTimer
}: {
  params: any;
  closeCurWindow: Function;
  winTimer: number;
}) {
  const {
    title: defaultTitle = "",
    scheduleTitle = "",
    timeDesc,
    sessionId = "",
    deepLink = ""
  } = params;
  const mid = Number(params?.mid || "");
  const beginTime = Number(params?.beginTime);
  const endTime = Number(params?.endTime);

  const [isDelete, setIsDeleted] = useState(false);
  const [isForceLogout, setIsForceLogout] = useState(false);
  const [timeDescState, setTimeDescState] = useState<string | boolean | null>(timeDesc);
  const [beforeMsg, setBeforeMsg] = useState("日程将于");
  const [afterMsg, setAfterMsg] = useState("后开始");
  let isCardClosed = false;
  const timer = useRef<any>(null);
  const wtimer = useRef<any>(null);
  const historyBeforeTime = useRef<any>(null);

  useEffect(() => {
    if (historyBeforeTime.current) {
      const nowTime = Date.now();
      let originTime = historyBeforeTime.current - nowTime;
      let timeFormat = getTimeFormat(originTime);
      let { hour, min } = timeFormat;
      if (originTime < 0 || (!hour && min <= 1)) {
        setTimeDescState(timeDesc);
        setBeforeMsg("日程将于");
        setAfterMsg("后开始");
      }
    }
    timer.current && clearTimeout(timer.current);
    refreshTime(beginTime, endTime);
    historyBeforeTime.current = beginTime;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [beginTime, endTime]);

  function refreshTime(beginTime: number, endTime: number) {
    try {
      // 开始时间和结束时间为空时不执行倒计时；
      if (beginTime && endTime) {
        intervalNextMin(() => {
          const nowTime = Date.now();
          let originTime = beginTime - nowTime;
          const isExpiredTime = nowTime >= endTime;
          if (isExpiredTime) {
            clearTimeout(timer.current);
            !isCardClosed && closeNoticeCard();
            isCardClosed = true;
          } else {
            let timeFormat = getTimeFormat(originTime);
            let { day, hour, min } = timeFormat;
            if (originTime < 0) {
              setBeforeMsg("日程已开始");
              setAfterMsg("");
            } else {
              if (!hour && min <= 1) {
                setBeforeMsg("日程即将开始");
                setAfterMsg("");
                min = 0;
              }
            }
            let dayStr = day ? day + "天" : "";
            let hourStr = hour ? hour + "小时" : "";
            let minutesStr = min ? min + "分钟" : "";
            setTimeDescState(dayStr + hourStr + minutesStr);
          }
        }, 60 * 1000);
      }
    } catch (e) {
      console.log(e);
    }
  }

  const closeNoticeCard = useCallback(() => {
    if (isFocusEnv()) {
      closeCurWindow?.();
    }
  }, [closeCurWindow]);

  function intervalNextMin(func: any, wait: any) {
    function getNextminTime() {
      const nowTime = Date.now();
      const seconds = new Date(nowTime).getSeconds();
      const milliseconds = new Date(nowTime).getMilliseconds();
      const newwait = wait - (seconds * 1000 + milliseconds);
      return newwait;
    }
    const newwait = getNextminTime();
    const interv = function () {
      const newwait = getNextminTime();
      func();
      clearTimeout(timer.current);
      timer.current = setTimeout(interv, newwait);
    };
    timer.current = setTimeout(interv, newwait);
  }

  function getTimeFormat(time: number) {
    let hourBase = 60 * 60 * 1000;
    let dayBase = 24 * hourBase;
    let timeResult = time;
    if (time < 0) {
      timeResult = -timeResult;
    }
    let day = Math.floor(timeResult / dayBase);
    let hour = new Date(timeResult - 8 * hourBase).getHours();
    let min = new Date(timeResult).getMinutes();
    if (time > 0) {
      min = min + 1;
    }
    return {
      day,
      hour,
      min
    };
  }

  const viewDetail = useCallback(() => {
    if (!isFocusEnv()) {
      return;
    }
    analysisLog("Xtbg_Schedule_ForcedPopup", "Details");
    if (!isForceLogout) {
      // 发送消息到桌面端
      analysisLog("xtbg_calhome_1640073907694", "46");
      DeeplinkEvent.open(deepLink, { from: ScheduleDetailFrom.WinNoticeCard });
      FocusSDK.sendIpcMessage("showMainwindow");
    }
    // tj: 已被踢出后直接关闭
    closeNoticeCard();
  }, [isForceLogout, closeNoticeCard, deepLink]);

  useEffect(() => {
    if (isDelete) {
      if (isFocusEnv()) {
        // 发送消息到桌面端
        closeNoticeCard();
      }
    }
  }, [isDelete, closeNoticeCard]);
  const readHandle = useCallback(async () => {
    analysisLog("Xtbg_Schedule_ForcedPopup", "Close");
    if (ImService.getInstance()) {
      // const _mid = Number(mid || '');
      // const _sessionId = sessionId || '';
      if (!isNaN(mid) && sessionId) {
        await ImService.getInstance().readMessageById(mid, sessionId);
      }
    }
    closeNoticeCard();
  }, [closeNoticeCard, mid, sessionId]);

  // tj: 强制退出 (解决强制退出后点击提醒页面卡死)
  const forceQuitListener = useCallback(() => {
    setIsForceLogout(true);
  }, []);

  useEffect(() => {
    Bus.on("chat:force_quit", forceQuitListener);
    return () => {
      Bus.off("chat:force_quit", forceQuitListener);
    };
  }, [forceQuitListener]);

  // 定时关闭
  useEffect(() => {
    if (winTimer) {
      wtimer.current = setTimeout(() => {
        analysisLog("Xtbg_Schedule_ForcedPopup", "AutoClose");
        closeNoticeCard();
      }, winTimer * 60 * 1000);
    }
    return () => {
      timer.current && clearTimeout(timer.current);
      wtimer.current && clearTimeout(wtimer.current);
      historyBeforeTime.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles["calendar-notice-card"]}>
      {/* <div className={styles["snc-spliter"]} /> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1
        }}
      >
        <div style={{ flex: 1, padding: "8px 16px 0" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            }}
          >
            <IconFont
              className={styles["scn-primary"]}
              style={{ fontSize: 20 }}
              type="iconic-pc-schedule"
            />
            <p className={styles["calendar-title"]}>
              {(timeDescState || Number(timeDescState) === 0) && timeDescState !== "undefined" ? (
                <span>
                  日程提醒：
                  <span style={{ color: `${colors.primary2}` }}>
                    {beforeMsg}
                    {timeDescState}
                    {afterMsg}
                  </span>
                </span>
              ) : defaultTitle ? (
                <span>
                  日程提醒：
                  <span style={{ color: `${colors.primary2}` }}>{defaultTitle}</span>
                </span>
              ) : (
                "日程提醒"
              )}
            </p>
            <IconFont className={styles["scn-close"]} type="iconty_close" onClick={readHandle} />
          </div>
          <p className={styles["snc-content"]}>
            <label>主题：</label>
            <span className={styles["snc-content-title"]}>{scheduleTitle}</span>
          </p>
          <p className={styles["snc-content"]}>
            <label>时间：</label>
            {Dayjs(beginTime).format("YYYY年MM月DD日 HH:mm")}
          </p>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
          <p className={styles["snc-btn"]} onClick={viewDetail}>
            {i18n.t("calendar:viewDetail")}
          </p>
          <p className={styles["snc-btn-primary"]} onClick={readHandle}>
            {i18n.t("calendar:close")}
          </p>
        </div>
      </div>
    </div>
  );
}
